import { Mail, Phone, MapPin, Clock } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { EnquiryForm } from "../components/EnquiryForm";
import QRShareCard from "../components/QRShareCard";
import { SITE } from "../lib/siteConfig";

const INFO = [
  { icon: Mail, label: "Business Email", value: SITE.email, href: `mailto:${SITE.email}`, id: "email" },
  { icon: Phone, label: "Phone Number", value: SITE.phone, href: `tel:${SITE.phone.replace(/\s/g, "")}`, id: "phone" },
  { icon: MapPin, label: "Office Address", value: SITE.address, href: null, id: "address" },
  { icon: Clock, label: "Business Hours", value: SITE.hours, href: null, id: "hours" },
];

export default function Contact() {
  return (
    <main>
      <PageHero
        testid="contact-hero"
        eyebrow="Contact Us"
        titleLines={["Let's Start the", "Conversation"]}
        description="Share your requirement and our team will reach out to guide you towards suitable loan options from banks and financial institutions."
      />

      <section className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-20 lg:pb-28" data-testid="contact-section">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
          <Reveal className="lg:col-span-3">
            <div className="card-gold p-7 sm:p-10 hover:!transform-none">
              <p className="caption-gold mb-3">Enquiry Form</p>
              <h2 className="font-display text-xl sm:text-2xl font-semibold text-white mb-8">Request Loan Assistance</h2>
              <EnquiryForm />
            </div>
          </Reveal>

          <div className="lg:col-span-2 space-y-5">
            {INFO.map((item, i) => (
              <Reveal key={item.id} delay={0.08 + i * 0.07}>
                <div className="card-gold p-6 hover:!transform-none" data-testid={`contact-info-${item.id}`}>
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 rounded-xl border border-[rgba(212,175,55,0.3)] bg-[#0A0A0D] flex items-center justify-center shrink-0">
                      <item.icon size={19} className="text-[#D4AF37]" strokeWidth={1.5} />
                    </div>
                    <div className="min-w-0">
                      <p className="text-xs text-[#71717A] tracking-wide mb-1.5">{item.label}</p>
                      {item.href ? (
                        <a href={item.href} data-testid={`contact-${item.id}-link`} className="text-sm text-[#F4F4F6] hover:text-[#E6CA65] transition-colors break-words">
                          {item.value}
                        </a>
                      ) : (
                        <p className="text-sm text-[#F4F4F6] leading-relaxed">{item.value}</p>
                      )}
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}

            <Reveal delay={0.4}>
              <div
                data-testid="contact-map-placeholder"
                className="rounded-2xl border border-dashed border-[rgba(212,175,55,0.35)] bg-[#0C0C10] h-44 flex flex-col items-center justify-center gap-3 text-center px-6"
              >
                <MapPin size={22} className="text-[#D4AF37]" strokeWidth={1.5} />
                <p className="text-xs text-[#71717A] leading-relaxed">
                  Office location map will be displayed here once the official address is confirmed.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.42}>
              <QRShareCard />
            </Reveal>

            <Reveal delay={0.45}>
              <p className="text-[11px] text-[#71717A] leading-relaxed px-1">
                We typically respond to enquiries within one business day. Loan approval is subject to the
                eligibility criteria and policies of the respective bank or financial institution.
              </p>
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
